<mat-toolbar class="mat-elevation-z3" [class.vertical]="isLandscape()">
  <div class="flex-row">
    @if(isMainLayout && currentProject()?.id){
    <lib-button color="none" textColor="primary" icon="arrow_back" (click)="goBack()">
    </lib-button>
    }

    @if ((isMobileSignal() )) {
    <lib-button color="none" textColor="primary" icon="menu" (click)="onToggleSidenav()">
    </lib-button>
    }

    <img *ngIf="isLandscape()" src="icons/icon-72x72.png" class="logo-vertical" alt="Unifield logo" (click)="goHome()" />
    <h1 *ngIf="!isLandscape()" class="logo" (click)="goHome()">UNIFIELD</h1>

    @if (!(isMobileSignal() )) {
    <app-dropdown-menu [nodes]="menuNodes" [userRole]="user?.role?.name"></app-dropdown-menu> }
  </div>

  <div class="flex-row">
    <app-notify></app-notify>

    @if (currentCompany(); as company) {
    <a class="company-pill" routerLink="/company" [matTooltip]="'companies.configure' | translate">
      <app-company-logo [name]="company.name" [logo]="company.logo" [size]="26"></app-company-logo>
      <span class="company-name">{{ company.name }}</span>
    </a>
    }

    <!-- PROFIL BUTTON  -->
    <div class="profile-btn" [matMenuTriggerFor]="menu">
      <app-user-avatar [avatarUrl]="currentUser().avatar" [firstName]="currentUser().firstName"
        [lastName]="currentUser().lastName" [size]="40" [showStatus]="false">
      </app-user-avatar>
    </div>

    <mat-menu #menu="matMenu" class="sub-menu">
      <div *ngIf="currentUser()" class="userInfo">
        <p>{{ currentUser().firstName }} {{ currentUser().lastName }}</p>
        <p>{{ currentUser().company }}</p>
      </div>

      <div *ngIf="!currentUser()">
        <p>User not found</p>
      </div>

      <button mat-menu-item [routerLink]="'/profile'">
        <mat-icon class="btn-icon">person_edit</mat-icon>
        <span>{{'menu.user.profile' | translate}}</span>
      </button>

      <button mat-menu-item [routerLink]="'/project-dashboard'">
        <mat-icon class="btn-icon">dashboard</mat-icon>
        <span>{{ "projects.project_dashboard" | translate }}</span>
      </button>

      @if(["admin", "dev", "userAdmin"].includes(currentUser()?.role?.name)){
      <button mat-menu-item [routerLink]="'/projects-status'">
        <mat-icon class="btn-icon" fontIcon="wifi"></mat-icon>
        <span>{{ "projects.status" | translate }}</span>
      </button>
      }

      <button (click)="logout()" mat-menu-item class="logout-btn">
        <mat-icon class="btn-icon">logout</mat-icon>
        <span>{{'menu.user.logout' | translate}}</span>
      </button>

      @if (menuCompanies().length) {
      <div class="menu-section">{{ 'companies.menu_title' | translate }}</div>
      @for (company of menuCompanies(); track company.id) {
      <button mat-menu-item class="company-item" [class.active]="company.id === currentCompany()?.id"
        (click)="selectCompany(company)">
        <span class="company-item-content">
          <app-company-logo [name]="company.name" [logo]="company.logo" [size]="24"></app-company-logo>

          <span class="company-item-name">{{ company.name }}</span>

          @if (company.id === currentCompany()?.id) {
          <mat-icon class="company-check">check</mat-icon>
          }
        </span>
      </button>
      }
      
      @if (isPrivileged()) {
      <button mat-menu-item [routerLink]="'/admin/companies'">
        <mat-icon class="btn-icon">domain</mat-icon>
        <span>{{ 'companies.see_all' | translate }}</span>
      </button>
      }
      }
    </mat-menu>
  </div>
</mat-toolbar>

@if (isLoadingProject()) {
<div class="project-loading-overlay">
  <div class="project-loading-content">
    <app-spinner [text]="'status.project_loading' | translate"></app-spinner>
  </div>
</div>
}